<!--
Displays the icon/text for a facility.

@author cm359n

-->
<template>
  <div :class="faIconClass(faIconName)">
    <font-awesome-icon v-if="faIconName" :icon="getIconData(assetImageName)" size="lg"></font-awesome-icon>
    <img class="assetImg" v-if="assetImageName" :alt="title" :src="getImage(assetImageName)" />
    <div class="fac-title">{{ title }}</div>
  </div>
</template>

<script setup>

const props = defineProps({
  faIconName: String,
  assetImageName: String,
  title: String
});

// some of our FontAwesome icons have a prefix e.g. far|play-circle, so we'll extract and use them
function getIconData () {
  const fadata = props.faIconName
  let ret = ['fas', fadata]
  if (fadata.indexOf(':') != -1) {
    ret = fadata.split(':').slice(0, 2)
  }
  return ret
}

function faIconClass (name) {
  if (typeof name === 'undefined') {
    return 'fac-svg-image'
  } else {
    return 'fac-fa-icon'
  }
}

function getImage (cat) {
  // stolen from Clubs.vue
  var images = require.context('@/assets/', false, /\.svg$/)
  return images('./' + cat)
}
</script>

<style>
.fac-title {
  margin-top:3px;
}
.fac-fa-icon {
  margin-top: 3px;
  color: #003865;
}
.fac-title {
  color: #003865;
}
.fac-svg-image {
  margin-top: 1px;
}
</style>
